module.exports = __webpack_public_path__ + "images/apartment-icon-d0a188aedcfa7b7dbcb2144149bd8407.svg";